<template>
  <footer class="app-footer">
    <div class="container">
      <p>{{ $i18n.t('footer.copyright') }}</p>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
.app-footer {
  background-color: #111827;
  padding: 1.88rem 0;
  text-align: left;
  border-top: 1px solid rgba(71, 121, 181, 0.2);
}

.app-footer .container {
  max-width: 85rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

.app-footer p {
  color: #94a3b8;
  font-size: 0.88rem;
  margin: 0;
}

@media (max-width: 48rem) {
  .app-footer {
    padding: 1.56rem 0;
  }

  .app-footer p {
    font-size: 0.75rem;
  }
}
</style>
